
(function(template){
  define('vue!optionalClassProgram/components/classComponents/mandatoryComponents/innerComponent',[
    "Vue",
    "helpers",
    "vuex",
    "moment",
    "vue!../classDescriptionComponent",

  ], function (
    Vue,
    helpers,
    vuex,
    moment,
    classDescriptionComponent
  ) {
    return {
      template: template,
      name: "",
      props: ['customerID','cascadeOption','item'],
      computed: _.extend(
        vuex.mapState(['users']), {
        }),
      components: {
          'classDescriptionComponent':classDescriptionComponent,
      },
    }
  })
})('<div> <classDescriptionComponent v-bind:item="item" v-bind:cascadeOption="cascadeOption"></classDescriptionComponent> </div>');
